import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const FileRequirements = ({
  fileReqView,
  maxSizeLabel,
  maxBatchSizeLabel,
  fileTypesLabel,
}) => {
  switch (fileReqView) {
    case 'ViewOne': return (
      <div className="flex flex-align-start font-weight-normal dls-grey-06 flex-align-self-stretch width-full dnuk-file-requirements-view-one" id="sizeLimits">
        { }
        <div tabIndex="0" className="flex-column width-full">
          <FormattedMessage
            id="maxSizeDescriptionLabel"
            values={{
              minSize: <span>{maxSizeLabel}</span>,
              maxSize: <span>{maxBatchSizeLabel}</span>,
              maxSizeDescriptionLabel: <FormattedMessage id="maxSizeDescriptionLabel" />,
            }}
          />
          <br />
          <FormattedMessage id="fileTypesLabelOne" />
          <span>{fileTypesLabel}</span>
        </div>
      </div>
    );
    default: return (

      <div tabIndex="0" className="flex-justify-center text-align-center" id="sizeLimits">
        <FormattedMessage id="maxSizeLabelDefault" />
        {maxSizeLabel}
        <br />
        <FormattedMessage id="maxBatchSizeLabelDefault" />
        {maxBatchSizeLabel}
        <br />
        <FormattedMessage id="fileTypesLabelDefault" />
        {fileTypesLabel}
      </div>
    );
  }
};

FileRequirements.propTypes = {
  maxSizeLabel: PropTypes.string.isRequired,
  maxBatchSizeLabel: PropTypes.string.isRequired,
  fileTypesLabel: PropTypes.string.isRequired,
  fileReqView: PropTypes.string.isRequired,
};

export default FileRequirements;
